import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
interface Body {
  destination: string;
  copy: string;
  bcc: string;
  course: string;
  firstname: string;
  lastname: boolean;
  meetingUrl: string;
  company: string;
}

@Injectable({
  providedIn: 'root'
})
export class MailService {
  public body: Body;

  constructor(private http: HttpClient) { }

  sendMessage(destination, course, firstName, lastName, copy, bcc, meetingUrl, company) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    // destination = "kasi_1991@hotmail.de";
    // course = "Test Kurs";
    // firstName = "Bernd"
    // name = "Brot";
    // copy = "kasi_1991@hotmail.de,kasi_1991@hotmail.de";
    this.body = ({
      destination: destination,
      course: course,
      firstname: firstName,
      lastname: lastName,
      copy: copy,
      bcc: bcc,
      meetingUrl: meetingUrl,
      company: company
    })

    return this.http.post("https://us-central1-reha-webpage.cloudfunctions.net/sendMail", this.body, { headers, responseType: 'text' });

  }
}